import { createApi } from '@reduxjs/toolkit/query/react';

import {
  SalePlansEndpoints as Endpoints,
  type ExportSalePlansToExcelByYearRequest,
  type ExportSalePlansToExcelByYearResponse,
  type GetSalesPlanRequest,
  type GetSalesPlanResponse,
  type UpdateSalePlansRequest,
  type UpdateSalePlansResponse,
} from '@app/api/SalePlans/types';
import { createApiBaseQuery, Methods } from '@app/api/shared';
import { SALE_PLANS_CHUNK } from '@app/constants';

export const salePlansApi = createApi({
  reducerPath: 'salePlansApi',
  baseQuery: createApiBaseQuery(SALE_PLANS_CHUNK),
  endpoints: ({ mutation, query }) => ({
    [Endpoints.UpdateSalePlans]: mutation<
      UpdateSalePlansResponse,
      UpdateSalePlansRequest
    >({
      query: ({ data, ...params }) => ({
        url: Endpoints.UpdateSalePlans,
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.GetSalesPlan]: query<GetSalesPlanResponse, GetSalesPlanRequest>({
      query: (params) => ({
        url: Endpoints.GetSalesPlan,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.ExportSalePlansToExcelByYear]: mutation<
      ExportSalePlansToExcelByYearResponse,
      ExportSalePlansToExcelByYearRequest
    >({
      query: (params) => ({
        url: Endpoints.ExportSalePlansToExcelByYear,
        method: Methods.POST,
        params,
      }),
    }),
  }),
});

export const {
  useUpdateSalePlansMutation,
  useGetSalesPlanQuery,
  useLazyGetSalesPlanQuery,
  useExportSalePlansToExcelByYearMutation,
} = salePlansApi;
